/**
 * Two-level deep equality check tailored for small config objects
 * (responsive props are at most: breakpoint key -> side key -> string value).
 *
 * Level 0: reference equality
 * Level 1: object key count + per-key reference equality
 * Level 2: nested object key count + per-key reference equality
 */
export function deepEqualShallow(a, b) {
    if (a === b)
        return true;
    if (typeof a !== typeof b)
        return false;
    if (typeof a !== 'object' || a === null || b === null)
        return false;
    const objA = a;
    const objB = b;
    const keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length)
        return false;
    for (const key of keysA) {
        const valA = objA[key];
        const valB = objB[key];
        if (valA === valB)
            continue;
        if (typeof valA === 'object' && valA !== null && typeof valB === 'object' && valB !== null) {
            const innerA = valA;
            const innerB = valB;
            const innerKeysA = Object.keys(innerA);
            if (innerKeysA.length !== Object.keys(innerB).length)
                return false;
            for (const innerKey of innerKeysA) {
                if (innerA[innerKey] !== innerB[innerKey])
                    return false;
            }
            continue;
        }
        return false;
    }
    return true;
}
//# sourceMappingURL=deepEqualShallow.js.map